import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { paymentApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${paymentApiUrl()}/api`;

export default createScopedApi(BASE_API_URL, axiosInstance);
